import { z } from 'zod';
export const CohortEnumSchema = z.enum(['csr', 'insured', 'estimator', 'super', 'technician']);
export const Cohort = CohortEnumSchema.enum;
export const isCohort = (maybeCohort) => CohortEnumSchema.safeParse(maybeCohort).success;
